// extracted by mini-css-extract-plugin
export default {"departments":"SF-z","departmentHeading":"TF-z","departmentSection":"UF-z","departmentName":"VF-z","departmentLink":"WF-z","expandIcon":"XF-z"};